// redux_files/authSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { jwtDecode } from "jwt-decode";

const initialState = {
  token: null,
  refresh: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login(state, action) {
      state.token = action.payload.access;
      state.refresh = action.payload.refresh;
    },
    logout(state) {
      state.token = null;
      state.refresh = null;
    },
    refreshToken(state, action) {
      state.token = action.payload.access;
    },
  },
});

export const { login, logout, refreshToken } = authSlice.actions;
export default authSlice.reducer;

// Selectors
export const selectIsAuthenticated = (state) => Boolean(state.auth.token);

export const selectUserDecoded = (state) => {
  try {
    return state.auth.token ? jwtDecode(state.auth.token) : null;
  } catch {
    return null;
  }
};
